import React, { useState } from 'react';
import { Button } from './ui/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/DropdownMenu';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from './ui/Sheet';
import { Phone, Menu, ChevronDown } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const serviceItems = ['Bistro Lights', 'Architectural Lights', 'Landscape Lights', 'Hardscape Lights', 'Sport Court Lights', 'Backyard Lights', 'Security Lights'];
  const serviceAreas = ['Chandler', 'Gilbert', 'Queen Creek', 'Mesa', 'Phoenix', 'Paradise Valley', 'Scottsdale', 'Fountain Hills', 'San Tan Valley', 'Tempe'];
  return <header className="sticky top-0 z-50 w-full bg-[var(--brand-black)] border-b border-white/10 backdrop-blur-sm" data-id="element-71">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="flex items-center justify-between h-20" data-id="element-73">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/f8cy29DHmDei39Mx1pqc62/Love_Outdoor_Light_Logo_New.png" alt="Love Outdoor Lighting" className="h-12 w-auto object-contain sm:h-14" data-id="element-75" />
            <span className="text-white font-bold text-base sm:text-lg uppercase tracking-wider leading-tight" data-id="element-76">
              Love Outdoor
              <br data-id="element-77" />
              Lighting
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-78">
            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-79">
              Home
            </a>

            <DropdownMenu data-id="element-80">
              <DropdownMenuTrigger className="flex items-center gap-1 text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-81">
                Services <ChevronDown className="w-4 h-4" data-id="element-82" />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-white" data-id="element-83">
                {serviceItems.map(service => <DropdownMenuItem key={service} className="cursor-pointer" data-id="element-84">
                    {service}
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-85">
              Projects
            </a>

            <DropdownMenu data-id="element-86">
              <DropdownMenuTrigger className="flex items-center gap-1 text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-87">
                Service Areas <ChevronDown className="w-4 h-4" data-id="element-88" />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-white" data-id="element-89">
                {serviceAreas.map(area => <DropdownMenuItem key={area} className="cursor-pointer" data-id="element-90">
                    {area}
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-91">
              Blog
            </a>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-92">
              Contact
            </a>
          </nav>

          {/* Right Side: CTA + Phone */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-93">
            <a href="tel:480-270-2014" className="flex items-center gap-2 text-white hover:text-[var(--brand-gold)] transition-colors" data-id="element-94">
              <Phone className="w-5 h-5" data-id="element-95" />
              <span className="font-medium" data-id="element-96">480-270-2014</span>
            </a>
            <Button className="bg-[var(--brand-green)] hover:bg-green-700 text-white font-medium" data-id="element-97">
              Get a Free Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen} data-id="element-98">
            <SheetTrigger asChild className="lg:hidden" data-id="element-99">
              <Button variant="ghost" size="icon" className="text-white" data-id="element-100">
                <Menu className="w-6 h-6" data-id="element-101" />
                <span className="sr-only" data-id="element-102">Open menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[var(--brand-black)] text-white border-white/10" data-id="element-103">
              <SheetHeader data-id="element-104">
                <SheetTitle className="text-white text-left" data-id="element-105">Menu</SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-6 mt-8" data-id="element-106">
                <a href="#" className="text-lg font-medium hover:text-[var(--brand-gold)] transition-colors" data-id="element-107">
                  Home
                </a>

                <div className="flex flex-col gap-3" data-id="element-108">
                  <span className="text-lg font-medium text-[var(--brand-gold)]" data-id="element-109">
                    Services
                  </span>
                  <div className="flex flex-col gap-2 pl-4" data-id="element-110">
                    {serviceItems.map(service => <a key={service} href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-111">
                        {service}
                      </a>)}
                  </div>
                </div>

                <a href="#" className="text-lg font-medium hover:text-[var(--brand-gold)] transition-colors" data-id="element-112">
                  Projects
                </a>

                <div className="flex flex-col gap-3" data-id="element-113">
                  <span className="text-lg font-medium text-[var(--brand-gold)]" data-id="element-114">
                    Service Areas
                  </span>
                  <div className="flex flex-col gap-2 pl-4" data-id="element-115">
                    {serviceAreas.map(area => <a key={area} href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-116">
                        {area}
                      </a>)}
                  </div>
                </div>

                <a href="#" className="text-lg font-medium hover:text-[var(--brand-gold)] transition-colors" data-id="element-117">
                  Blog
                </a>

                <a href="#" className="text-lg font-medium hover:text-[var(--brand-gold)] transition-colors" data-id="element-118">
                  Contact
                </a>

                <div className="flex flex-col gap-4 pt-6 border-t border-white/10" data-id="element-119">
                  <a href="tel:480-270-2014" className="flex items-center gap-2 text-white" data-id="element-120">
                    <Phone className="w-5 h-5 text-[var(--brand-gold)]" data-id="element-121" />
                    <span className="font-medium" data-id="element-122">480-270-2014</span>
                  </a>
                  <Button className="w-full bg-[var(--brand-green)] hover:bg-green-700 text-white font-medium" data-id="element-123">
                    Get a Free Quote
                  </Button>
                </div>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}